import { BankAccountItemSkeleton } from '../../components'

export function AddVezgoSkeleton() {
    return (
        <div className='w-full'>
            <div className='flex flex-col items-start animate-pulse'>
                <div className='w-48 h-8 rounded bg-skeleton'></div>
                <div className='w-full h-4 mt-6 rounded bg-skeleton'></div>
                <div className='w-1/2 h-4 mt-4 rounded bg-skeleton'></div>

                <div className='w-full mt-12'>
                    <BankAccountItemSkeleton />
                </div>
                <div className='w-1/3 h-4 mt-4 rounded bg-skeleton'></div>

                <div className='w-2/3 h-16 mt-8 rounded bg-skeleton'></div>
            </div>
        </div>
    )
}
